<template>
  <div class="virtual-student-dropdown" @mousedown.prevent>
    <div v-if="loading" class="virtual-student-empty">
      <a-spin :tip="$t('all.loadingText')" />
    </div>
    <div v-else-if="!items.length" class="virtual-student-empty">
      {{ $t("error.aucEleve") }}
    </div>
    <div
      v-else
      ref="viewport"
      class="virtual-student-viewport"
      @scroll="onScroll"
    >
      <div
        class="virtual-student-spacer"
        :style="{ height: totalHeight + 'px' }"
      >
        <div
          v-for="item in visibleItems"
          :key="item._id"
          class="ant-select-dropdown-menu-item virtual-student-option"
          :class="{
            'ant-select-dropdown-menu-item-selected': !!selectedMap[item._id],
          }"
          :style="{ top: item._top + 'px' }"
          :title="item.displayName"
          @click="$emit('toggle', item._id)"
        >
          {{ item.displayName }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const ITEM_HEIGHT = 32;
const VIEWPORT_HEIGHT = 256;
const BUFFER = 8;

export default {
  name: "StudentVirtualList",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    selectedIds: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      scrollTop: 0,
    };
  },
  computed: {
    selectedMap() {
      const map = {};
      (this.selectedIds || []).forEach((id) => {
        map[id] = true;
      });
      return map;
    },
    totalHeight() {
      return this.items.length * ITEM_HEIGHT;
    },
    visibleItems() {
      const start = Math.max(
        0,
        Math.floor(this.scrollTop / ITEM_HEIGHT) - BUFFER
      );
      const visibleCount = Math.ceil(VIEWPORT_HEIGHT / ITEM_HEIGHT) + BUFFER * 2;
      const end = Math.min(this.items.length, start + visibleCount);
      return this.items.slice(start, end).map((item, index) => ({
        ...item,
        _top: (start + index) * ITEM_HEIGHT,
      }));
    },
  },
  watch: {
    items() {
      this.scrollTop = 0;
      this.$nextTick(() => {
        if (this.$refs.viewport) this.$refs.viewport.scrollTop = 0;
      });
    },
  },
  updated() {
    if (this.$refs.viewport && this.$refs.viewport.scrollTop !== this.scrollTop) {
      this.$refs.viewport.scrollTop = this.scrollTop;
    }
  },
  methods: {
    onScroll(e) {
      this.scrollTop = e.target.scrollTop;
    },
  },
};
</script>
<style scoped>
.virtual-student-viewport {
  max-height: 256px;
  overflow-y: auto;
  overflow-x: hidden;
}
.virtual-student-spacer {
  position: relative;
  width: 100%;
}
.virtual-student-option {
  position: absolute;
  left: 0;
  right: 0;
  height: 32px;
  line-height: 32px;
  padding: 0 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
.virtual-student-empty {
  padding: 16px 12px;
  text-align: center;
  color: rgba(0, 0, 0, 0.45);
}
</style>
